import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize i18n
import "./core/i18n/i18n";

// Phase 1D — Sentry init runs BEFORE <App /> mounts so the React
// error boundary integration captures render errors. No-op when
// VITE_SENTRY_DSN is empty (dev / staging without a Sentry project).
import { initSentry } from "./core/observability/sentry";
initSentry();

// In-house error sink (shaka-api `apps/errors/`). Runs alongside
// Sentry — Sentry remains the ops dashboard, this feeds the
// shaka-admin triage inbox + AI-review flow. Best-effort POSTs;
// silently drops if the sink endpoint is unreachable.
import { installErrorReporter } from "./core/observability/errorReporter";
installErrorReporter({ app: 'deck' });

createRoot(document.getElementById("root")!).render(<App />);
